import { useState } from "react";
import { ArrowIcon } from "../../assets/icons";
import classNames from "classnames";

import styles from "./accordion.module.css";

import { Text } from "../text/text";

const AccordionItem = ({ isActive, setIsActive, title, description }) => {
    return (
        <div className={classNames(styles.accordion_item_container, { [styles.active]: isActive })} onClick={setIsActive}>
            <div className={styles.accordion_item_info}>
                <Text tag="div" view="heading" className={styles.accordion_item_title} size={14} weight={700}>{title}</Text>
                <div className={styles.accordion_item_description_container}>
                    <div style={{ minHeight: "0", overflow: "hidden" }}>
                        <Text tag="div" view="body" className={styles.accordion_item_description} >{description}</Text>
                    </div>
                </div>
            </div>
            <div className={styles.accordion_item_arrow}>
                <ArrowIcon angle={(isActive ? -90 : 90)} />
                <div className={styles.spring} />
            </div>
        </div>
    )
}

export const Accordion = ({ data }) => {
    const [activeElement, setActiveElement] = useState(-1)

    return (
        <div className={styles.accordion_container}>
            {
                data.map((el, i) => <AccordionItem isActive={activeElement === i} setIsActive={() => setActiveElement(prev => (prev === i) ? -1 : i)} title={el.title} description={el.description} key={el.id} />)
            }
        </div>
    )
}